import { useEffect } from 'react'
import { useBogo } from '@mc/bogo-utils'
import { useBucket } from '@mc/experiments-react'
import { usePromotion } from '@mc/promo-utils'
import { trackExperimentViewed } from '@mc/track-event'
import { PERSONALIZED_STICKY_FOOTER_EXP_FLAG } from './constants'

export const usePersonalizedStickyFooterExp = () => {
  const bucket = useBucket(PERSONALIZED_STICKY_FOOTER_EXP_FLAG)
  const { isBogoOfferEligible } = useBogo()
  const { isPromotionOn } = usePromotion()

  const hideStickyFooter = isBogoOfferEligible || isPromotionOn

  useEffect(() => {
    if (!hideStickyFooter) {
      trackExperimentViewed(PERSONALIZED_STICKY_FOOTER_EXP_FLAG)
    }
  }, [hideStickyFooter])

  return { isVariant: !hideStickyFooter && bucket?.includes('variant') }
}
